import React from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import Dropzone from '../dropzone/Dropzone';

const FileParser = ({
    onRead, parseMethod, onAbort, onError
}) => {
    const readFile = (file) => {
        const reader = new FileReader();
        reader.onabort = onAbort;
        reader.onerror = onError;
        reader.onload = () => {
            onRead(parseMethod(reader.result));
        };

        reader.readAsText(file);
    };

    return (
        <Dropzone
            onDrop={ readFile }
        />
    );
};

FileParser.propTypes = {
    onAbort: PropTypes.func,
    onError: PropTypes.func,
    onRead: PropTypes.func,
    parseMethod: PropTypes.func,
};

FileParser.defaultProps = {
    onAbort: fp.noop,
    onError: fp.noop,
    onRead: fp.identity,
    parseMethod: fp.identity,
};

export default FileParser;
